<template>
  <b-modal
    :id="id"
    size="sm"
    centered
    hide-header
    hide-footer
  >
    <div class="container-fluid no-pad">
      <div class="row">
        <div class="col-12 text-right">
            <a class="close" @click="$emit('cancel')"><i class="far fa-times-circle fa-2x"></i></a>
        </div>
      </div>
      <div class="row text-center mt-3">
        <div class="col-sm-12">
          <p class="font-weight-bold">{{ message }}</p>
        </div>
        <div class="col-sm-12 no-pad">
          <button type="button" class="btn btn-hc w-40 mr-2 mb-3" @click="$emit('ok')">Yes</button>
          <button type="button" class="btn btn-hc w-40 ml-2 mb-3" @click="$emit('cancel')">No</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
	name: 'ConfirmationModal',
	props: {
		id: {
			type: String,
			required: false,
		},
		message: {
			type: String,
			required: false,
		},
	},
};
</script>
